import React from 'react';
import { useRef, useEffect } from "react";
import './About.scss';

function About() {
    return (
        <section id='about'>
            <div className="about-container">
                <div className="widget">
                    <div className="widget-about">
                        <div className="about-title">
                            <h3>About</h3>
                        </div>
                        <div className="about-body">
                            <p>I am an undergraduate student majoring in Computer Engineering who eagers to take on challenging problems. I am passionate about solving problems through code and learning more about new technologies. </p>
                        </div>
                    </div>
                    <div className="widget-skills">
                        <div className="skills-title">
                            <h3>Skills</h3>
                        </div>
                        <div className="skills-body">
                            <ul className='list-items'>
                                <li className='item'>
                                    <span><span className='numbers'>01/ </span>full-stack web development (Django, React)</span>
                                </li>
                                <li className='item'>
                                    <span><span className='numbers'>02/ </span>Skilled in Python, C, C++, java</span>
                                </li>
                                <li className='item'>
                                    <span><span className='numbers'>03/ </span>Ability to learn quickly and write clean, efficient code.</span>
                                </li>
                                <li className='item'>
                                    <span><span className='numbers'>04/ </span>Strong problem-solving, analytical, and communication skills</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;